module.exports = __webpack_public_path__ + "static/img/banner-about-05.0f7f493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-about-05.jpg
// module id = LGgZ
// module chunks = 100